import { TypedDocumentNode, gql } from '@apollo/client';

import { OverlappingAvatars } from '@sorare/core/src/components/rivals/OverlappingAvatars';

import { MyAvailableCards_footballRivalsGame } from './__generated__/index.graphql';

type Props = { footballRivalsGame: MyAvailableCards_footballRivalsGame };

export const MyAvailableCards = ({ footballRivalsGame }: Props) => {
  const { myAvailableCards } = footballRivalsGame;
  if (!(myAvailableCards.totalCount > 0)) {
    return null;
  }

  return (
    <OverlappingAvatars
      size={2.5}
      avatars={myAvailableCards.cards.map(({ slug, avatarUrl, rarity }) => ({
        slug,
        avatarUrl,
        scarcity: rarity || undefined,
      }))}
      additionalPlayersCount={
        myAvailableCards.totalCount - myAvailableCards.cards.length
      }
    />
  );
};

MyAvailableCards.fragments = {
  footballRivalsGame: gql`
    fragment MyAvailableCards_footballRivalsGame on FootballRivalsGame {
      slug
      myAvailableCards {
        totalCount
        cards {
          slug
          rarity
          avatarUrl: pictureUrl(derivative: "avatar")
        }
      }
    }
  ` as TypedDocumentNode<MyAvailableCards_footballRivalsGame>,
};
